<template>
  <v-app light>
    <v-navigation-drawer
      v-model="isDrawerOpen"
      app
      clipped
    >
      <v-list
        class="pt-5"
        dense
        rounded
      >
        <v-list-item
          v-for="item in drawerItems"
          :key="item.name"
          active-class="secondary white--text"
          :to="item.href"
          link
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
      color="white"
    >
      <v-app-bar-nav-icon
        class="mr-5"
        @click.stop="isDrawerOpen = !isDrawerOpen"
      />

      <v-img
        contain
        class="mr-2"
        max-width="50"
        max-height="50"
        src="@/assets/images/commons/haulier-logo.svg"
      />

      <v-spacer />
      <v-list-item
        class="ml-auto flex-0"
        two-line
      >
        <v-list-item-content class="text-right">
          <v-list-item-title
            class="primary--text font-weight-bold"
          >
            {{ currentUser.email }}
          </v-list-item-title>
          <v-list-item-subtitle
            class="caption"
          >
            Haulier User
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-avatar>
          <v-icon
            class="primary lighten-1"
            dark
          >
            mdi-account
          </v-icon>
        </v-list-item-avatar>
      </v-list-item>

      <v-menu
        offset-y
        bottom
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            class="px-5"
            @click="logout"
          >
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main style="background: #f5f6fa">
      <v-container
        class="pa-5"
        fluid
        light
      >
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { auth } from '@/firebase';

export default {
  data() {
    return {
      currentUser: auth.currentUser,
      isDrawerOpen: true,
      drawerItems: [
        {
          name: 'Dashboard',
          icon: 'mdi-view-dashboard-outline',
          href: '/dashboard',
        },
        {
          name: 'Purchase Orders',
          icon: 'mdi-handshake-outline',
          href: '/purchase-orders',
        },
        {
          name: 'Delivery Requests',
          icon: 'mdi-truck-outline',
          href: '/delivery-requests',
        },
        {
          name: 'Products',
          icon: 'mdi-border-all',
          href: '/products',
        },
        {
          name: 'Locations',
          icon: 'mdi-map-marker-outline',
          href: '/locations',
        },
      ],
    };
  },
  methods: {
    logout() {
      auth.signOut().then(() => {
        this.$router.push('/accounts/login');
      });
    },
  },
};
</script>

<style>
.flex-0 {
  flex: 0;
}
</style>
